export default __webpack_public_path__ + "static/media/triangleBlue.c747a1ae.svg";